module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "bloc bgc-white l-bloc",
    attrs: {
      "id": "bloc-0"
    }
  }, [_c('div', {
    staticClass: "container bloc-sm"
  }, [_c('nav', {
    staticClass: "navbar row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse navbar-1"
  }, [_c('ul', {
    staticClass: "site-navigation nav navbar-nav"
  }, [(!_vm.$store.state.auth.authenticated) ? [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'register.index'
      }
    }
  }, [_vm._v("Rekisteröidy")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'login.index'
      }
    }
  }, [_vm._v("Kirjaudu sisään")])], 1)] : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.authenticated) ? [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'projects.index'
      }
    }
  }, [_vm._v("Projektit")])], 1), _vm._v(" "), _c('li', [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'profile-settings.index'
      }
    }
  }, [_vm._v("Muokkaa profiilia")])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_vm._v("Kirjaudu ulos")])])])])] : _vm._e()], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "a-btn a-block logo ltc-midnight-blue",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Coneron")]), _vm._v(" "), _c('button', {
    staticClass: "ui-navbar-toggle navbar-toggle",
    attrs: {
      "id": "nav-toggle",
      "type": "button",
      "data-toggle": "collapse",
      "data-target": ".navbar-1"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _c('span', {
    staticClass: "icon-bar"
  }), _c('span', {
    staticClass: "icon-bar"
  }), _c('span', {
    staticClass: "icon-bar"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tProfiili "), _c('span', {
    staticClass: "caret"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-16d911b3"}!./src/app/components/navbar/navbar.html
// module id = 460
// module chunks = 1